<template>
<b-container fluid>
  <br>
  <h1>Login</h1>
  <h2 v-if="wrongCred">Wrong credentials entered!. Please enter your correct details.</h2>
  <b-row class="justify-content-md-center">
    <b-col lg="4" sm="8" md="6">
      <b-form v-on:submit.prevent="loginUser">
          <b-form-group
      id="fieldset-1"
      label="Email"
      label-align="left"
      label-for="email-id"
    >
    <b-form-input id="email-id" v-model="email"></b-form-input>
          </b-form-group>

    <b-form-group
    id="fieldset-2"
    label="Password"
    label-align="left"
    label-for="password-id"
  >
    <b-form-input class="mb-4" id="password-id" v-model="password" type="password"></b-form-input>
    </b-form-group>
   <b-button id="submit-id" type="submit" block variant="outline-primary">Login</b-button>
      </b-form>
      <br>
      <p>No Account? <router-link :to="{name:'register'}">Create one</router-link></p>
      <p v-if="wrongCred">Forgot Password? <router-link :to="{name:'password-reset-request'}">Reset here</router-link></p>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            password: '',
            wrongCred: false // activates appropriate message if set to true
        }
    },

    mounted() {
        if(this.$route.query.a){
            this.$parent.showAlert(this.$route.query.a)
        }
    },
    methods: {
        loginUser() { // call loginUser action
            this.$store.dispatch('loginUser', {
                email: this.email.toLowerCase(),
                password: this.password
            })
                .then(() => {
                    this.wrongCred = false
                    this.$gtag.event('login', { method: 'Login' })
                    if(this.$route.query.redirect) {
                        this.$router.push(this.$route.query.redirect)
                    } else{
                        this.$router.push('/')
                    }
                })
                .catch(err => {
                    this.wrongCred = true // if the credentials were wrong set wrongCred to true
                })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login.vue